import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    saveDivision,
    editData,
    getEstatesByGroupID,
    getDivisionFilterData,

};
async function saveDivision(data) {
    let division = {
        collectionPointID: 0,
        collectionPointCode: data.collectionPointCode,
        collectionPointName: data.collectionPointName.trim(),
        collectionPointLocation: data.collectionPointLocation.trim(),
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID: parseInt(data.collectionCategoryID),
        operationEntityTypeID: 2,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,
        groupID: parseInt(data.groupID)
    }
    const response = await CommonPost('/api/CollectionPoint/SaveDivision', null, division);
    return response;
}

async function editData(data) {
    let division = {
        collectionPointID: data.collectionPointID,
        collectionPointCode: data.collectionPointCode,
        collectionPointName: data.collectionPointName.trim(),
        collectionPointLocation: data.collectionPointLocation == null ? "" : data.collectionPointLocation.trim(),
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID: parseInt(data.collectionCategoryID),
        operationEntityTypeID: 2,
        createdBy: data.createdBy,
        createdDate: data.createdDate,
        modifiedBy: data.modifiedBy,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,
        groupID: parseInt(data.groupID)
    }
    const response = await CommonPost('/api/CollectionPoint/UpdateDivision', null, division);
    return response;
}

async function getDivisionFilterData(data) {
    var divisionFilterModel = {
        groupID: (data.groupID),
        operationEntityID: (data.operationEntityID),
    }
    const response = await CommonPost('/api/CollectionPoint/FilterDivision', null, divisionFilterModel);
    return response.data;
}

async function getEstatesByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

